<template>
  <b-modal id="column-filter-string-modal" v-model="active" centered hide-footer hide-header @close="close">
    <svg-icon name="times-bold" :size="8" class="modal-dialog__close" @click="close"></svg-icon>

    <div class="m-column-filters">
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="condition"
            class="m-column-filters__condition"
            size="small"
            type="select"
            :items="conditions"
          />
        </div>
        <div class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model="value"
            class="m-column-filters__value m-column-filters__value_string"
            placeholder-style="italic"
            placeholder="Введите не менее 3 символов"
            size="small"
            :input-text-condition="error"
          />
        </div>
        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="apply"
          />
          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="reset"
          />
          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="reset" />
          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="apply" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import SvgIcon from "@/components/svg-icon";

const conditions = [
  { label: "Поиск по подстроке", value: "2" },
  { label: "Точное совпадение", value: "1" },
];

export default {
  name: "string-filter",
  components: {
    "c-button": Button,
    "c-input": Input,
    SvgIcon,
  },

  data() {
    return {
      active: false,
      submitted: false,

      conditions,
      condition: conditions[0],
      value: "",
    };
  },

  computed: {
    error() {
      if (this.submitted && this.value.length > 0 && this.value.length < 1) {
        return "Введите не менее 1-го символа";
      }
      return false;
    },
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (this.active && event.keyCode === 13) {
        this.apply();
      }
    });
  },

  methods: {
    getParams() {
      if (!this.value) return null;
      return {
        value: this.value,
        searchType: this.condition.value,
      };
    },
    open(params) {
      this.resetValue();

      if (params) {
        const { searchType } = params;
        const condition = this.conditions.find((c) => c.value === searchType);
        this.condition = condition || conditions[0];
        this.value = params.value;
      }

      this.active = true;
    },
    close() {
      this.active = false;
      this.submitted = false;
      this.$emit("close");
    },
    resetValue() {
      this.value = "";
      const [firstCondition] = conditions;
      this.condition = firstCondition;
    },
    reset() {
      this.$emit("apply", null);
      this.close();
    },

    apply() {
      this.submitted = true;
      if (this.error) return;

      this.$emit("apply", this.getParams());
      this.close();
    },
  },
};
</script>
